import React from "react";
import image1 from '../../assets/icons/handshaking.png'
const JoinUs = () => {
  return (
    <section id="why-us" className="why-us">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-12 d-flex align-items-stretch">
            <div className="content">
              <h3 id="roboto"><img className="center" width={"70px"} src={image1} /> Join Us on This Journey  </h3>
              <p>
                Become part of the NetNexa community today. Whether you're
                seeking career growth or looking to expand your professional
                network, NetNexa is the platform for you. Join us on this
                exciting journey and unlock a world of opportunities.{" "}
              </p>
              <div className="text-center">
                <a href="/about" className="more-btn">
                  Learn More <i className="bx bx-chevron-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div
            className="col-lg-8 d-flex align-items-stretch"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <div className="icon-boxes d-flex flex-column justify-content-center"></div>
            {/* End .content */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinUs;
